import { Component, Input, ElementRef, OnInit, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vg-scrub-bar-thumbnail-overlay',
    encapsulation: ViewEncapsulation.None,
    template: `<div><span class="thumbnail" [class.show]="showThumbnail" [style.background-image]="'url(' + thumbnail + ')'" [style.left]="xPosition"></span></div>`,
    styles: [ `
        vg-scrub-bar-thumbnail-overlay {
            display: flex;
            width: 100%;
            height: 20px;
            position: absolute;
        }

        .thumbnail{
            position: absolute;
            top: -100px;
            height: 100px;
            width: 177px;
            background-size: cover;
            background-color: black;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.3s ease-out;
        }

        .thumbnail.show{
            opacity: 1;
        }
        vg-controls vg-scrub-bar-thumbnail-overlay {
            position: absolute;
            top: calc(50% - 10px);
        }
    ` ]
})
export class VgScrubBarThumbnailOverlay implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() duration: number;
    @Input() src: string;
    @Input() slice: number = 10;

    elem: HTMLElement;
    target: any;

    subscriptions: Subscription[] = [];

    public thumbnail:string = '';
    public xPosition: string = '0px';
    public showThumbnail:boolean = false;
    private thumbnailList:Thumbnail[] = [];

    constructor(ref: ElementRef, public API: VgAPI) {
        this.elem = ref.nativeElement;
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);

        const duration = this.duration;
        const filename = this.src;
        const filenameRegex = /(.*)\.[^.]+$/
        const url = new URL('https:'+filename);
        const truncatedFilename = url.pathname.match(filenameRegex)[1];

        //http://nra-videos.s3.amazonaws.com/assets/00_08_29_12_cc_james_inhofe_08_29_12_cc/00_08_29_12_cc_james_inhofe_08_29_12_cc_234p-00001.jpg
        //http://nra-videos.s3.amazonaws.com/assets/00_08_29_12_cc_james_inhofe_08_29_12_cc/00_08_29_12_cc_james_inhofe_08_29_12_cc.m3u8
        const numThumbnails = Math.floor(duration / this.slice);
        for(let i:number = 0; i < numThumbnails; i++)
        {
            this.thumbnailList.push({thumbUrl: 'https://' + url.hostname + truncatedFilename + '_234p-' + ('0000' + (i+1)).slice(-5) + '.jpg', percentage: i / numThumbnails});
        }
    }

    @HostListener('mousemove', [ '$event' ])
    onMouseMoveScrubBar($event: any) {
        if (!this.target.isLive && this.thumbnailList.length > 0) {
            const percentage = $event.offsetX / this.elem.offsetWidth;
            const validThumbnails:Thumbnail[] = this.thumbnailList.filter(thumbnail => thumbnail.percentage < percentage);
            if(($event.offsetX + 177/2) > this.elem.offsetWidth)
            {
                this.xPosition = (this.elem.offsetWidth - 177) + "px";
            }
            else if($event.offsetX - 177/2 < 0)
            {
                this.xPosition = (0) + "px";
            }
            else{
                this.xPosition = ($event.offsetX - 177/2) + "px";
            }
            

            this.thumbnail = validThumbnails.pop().thumbUrl;
            this.showThumbnail = true;
        }
    }

    @HostListener('mouseout', [ '$event' ])
    onMouseOutScrubBar($event: any) {
        this.showThumbnail = false;
        this.thumbnail = '';
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    
}

interface Thumbnail {
    thumbUrl: string;
    percentage: number;
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-scrub-bar-thumbnail-overlay.ts